import { Injectable } from '@angular/core';
import { MessageService } from '@sla-ng/core';
import { IMeasureUnit } from '../../../models/measure-unit.model';
import { IMeasureUnitState } from './measure-unit.state.model';
import { FieldType } from '@sla-ng/ui-material';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { MeasureUnitResource } from '../../../resources/measure-unit.resource';

let _state: IMeasureUnitState = {
    isLoading: false,
    columns: [ 'name', 'shortName', 'erpMeasureNr', 'actions' ],
    dialogFields: [
        { field: 'name', label: 'app.model.measure-unit.name.label', type: FieldType.text, required: true },
        { field: 'shortName', label: 'app.model.measure-unit.shortName.label', type: FieldType.text, required: false },
        { field: 'erpMeasureNr', label: 'app.model.measure-unit.erpMeasureNr.label', type: FieldType.text, required: false },
    ],
};

@Injectable({
    providedIn: 'root',
})
export class MeasureUnitFacade {
    protected store$: BehaviorSubject<IMeasureUnitState> = new BehaviorSubject<IMeasureUnitState>(_state);

    constructor(private myMeasureUnitResource: MeasureUnitResource,
                private myMessageService: MessageService) {
    }

    public getStateSnapshot(): IMeasureUnitState {
        return this.store$.value;
    }

    public subState(): Observable<IMeasureUnitState> {
        return this.store$.asObservable();
    }

    public async addMeasureUnit(measureUnit: IMeasureUnit): Promise<void> {
        const createdMeasureUnit: IMeasureUnit = await this.myMeasureUnitResource.createMeasureUnit(measureUnit).toPromise().catch(() => null);
        if (createdMeasureUnit !== null) {
            this.myMessageService.successTrans('app.actions.feedback.saved', 'app.page.measure-unit.actions.added.label');
        }
    }

    public async updateMeasureUnit(measureUnit: IMeasureUnit): Promise<void> {
        const updatedMeasureUnit = await this.myMeasureUnitResource.updateMeasureUnit(measureUnit).toPromise().catch(() => null);
        if (updatedMeasureUnit !== null) {
            this.myMessageService.successTrans('app.actions.feedback.saved', 'app.page.measure-unit.actions.edited.label');
        }
    }

    public async deleteMeasureUnit(measureUnitId: number): Promise<void> {
        this.setIsloading(true);
        try {
            await firstValueFrom(this.myMeasureUnitResource.deleteMeasureUnit(measureUnitId));
            this.myMessageService.successTrans('app.actions.feedback.saved', 'app.page.measure-unit.actions.deleted.label');
        } catch (e) {
            console.error(e);
        }
        this.setIsloading(false);
    }

    public clearState(): void {
        this.updateState({
            isLoading: false,
            columns: [ 'name', 'shortName', 'erpMeasureNr', 'actions' ],
            dialogFields: [
                { field: 'name', label: 'app.model.measure-unit.name.label', type: FieldType.text, required: true },
                { field: 'shortName', label: 'app.model.measure-unit.shortName.label', type: FieldType.text, required: false },
                { field: 'erpMeasureNr', label: 'app.model.measure-unit.erpMeasureNr.label', type: FieldType.text, required: false },
            ]
        });
    }

    private setIsloading(isLoading: boolean): void {
        this.updateState({ ..._state, isLoading });
    }

    private updateState(state: IMeasureUnitState): void {
        this.store$.next(_state = state);
    }
}
